module.exports = __webpack_public_path__ + "img/BlinkArt_Axe1H_Epic.a83eb048.png";